import React from 'react';
export function Footer() {
  return <footer className="bg-[#1a1208] py-10 px-4 text-center" data-id="element-164">
      <div className="container mx-auto" data-id="element-165">
        <p className="text-[#d4a017]/60 text-xs tracking-[0.3em] uppercase mb-3" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-166">
          Formación Integral
        </p>
        <h3 className="text-xl font-serif font-bold text-white mb-5" data-id="element-167">
          Reiki · Sana · Transforma
        </h3>
        <div className="flex justify-center gap-6 mb-6 text-sm text-[#d4a017]/50" data-id="element-168">
          <a href="#" className="hover:text-[#d4a017] transition-colors" data-id="element-169">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-[#d4a017] transition-colors" data-id="element-170">
            Política de Privacidad
          </a>
        </div>
        <p className="text-xs text-[#5c4a2a]/40 max-w-lg mx-auto leading-relaxed" data-id="element-171">
          © 2025 Formación Reiki. Todos los derechos reservados. Este sitio no
          es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </div>
    </footer>;
}